import { SearchOutlined } from '@ant-design/icons';
// import type { DatePickerProps } from 'antd';
import { Col, Input, Row, Space, TreeSelect, Tooltip } from 'antd';
// import dayjs from 'dayjs';
// import moment from 'moment';
import { FC, useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import './index.scss';
import { SearchAndFilterProps } from './types';
import PayPeriodFilter from 'components/Global/PayPeriodFilter';
import ClearFilter from 'components/Global/ClearFilter';
import { createModifiedArray, getOptionLabel } from 'utils/utils';
// import { MaximizeIcon, MinimizeIcon } from 'utils/svgs';
// For search filter and paginate
const SearchAndFilter: FC<SearchAndFilterProps> = (props) => {
	// Init
	const {
		performFilterHandler,
		performSearchHandler,
		onChangePayPeriod,
		searchValue,
		filterValue,
		selectedPayPeriod,
		clearFilter,
		// isCostAllocation,
		// onScreenChange,
		// isExpanded,
	} = props;

	const { optionData: customer } = useSelector((state: any) => state.customer);
	const { optionData: classList } = useSelector((state: any) => state.class);
	const { data: employees } = useSelector((state: any) => state.employees);

	const { data: configurations } = useSelector(
		(state: any) => state?.configuration
	);

	const [filteredClassList, setFilteredClassList] = useState(classList);
	// Local state for immediate UI updates
	const [localEmployeeIds, setLocalEmployeeIds] = useState<string[]>(
		filterValue?.employeeId || []
	);
	const [localCustomerIds, setLocalCustomerIds] = useState<string[]>(
		filterValue?.customerId || []
	);
	const [localClassIds, setLocalClassIds] = useState<string[]>(
		filterValue?.classId || []
	);
	const [employeesTooltipDisabled, setEmployeesTooltipDisabled] = useState(false);
	const [customersTooltipDisabled, setCustomersTooltipDisabled] = useState(false);
	const [classesTooltipDisabled, setClassesTooltipDisabled] = useState(false);

	// Debounce refs for filters
	const employeeDebounceRef = useRef<NodeJS.Timeout | null>(null);
	const customerDebounceRef = useRef<NodeJS.Timeout | null>(null);
	const classDebounceRef = useRef<NodeJS.Timeout | null>(null);

	// Sync local state with filterValue when it changes externally (e.g., clear filter)
	useEffect(() => {
		setLocalEmployeeIds(filterValue?.employeeId || []);
	}, [filterValue?.employeeId]);

	useEffect(() => {
		setLocalCustomerIds(filterValue?.customerId || []);
	}, [filterValue?.customerId]);

	useEffect(() => {
		setLocalClassIds(filterValue?.classId || []);
	}, [filterValue?.classId]);

	// Debounced handlers for filters
	const debouncedSetEmployees = useCallback(
		(employeeIds: string[]) => {
			setLocalEmployeeIds(employeeIds); // Update UI immediately
			if (employeeDebounceRef.current) {
				clearTimeout(employeeDebounceRef.current);
			}
			employeeDebounceRef.current = setTimeout(() => {
				performFilterHandler('employeeId', employeeIds);
			}, 500);
		},
		[performFilterHandler]
	);

	const debouncedSetCustomers = useCallback(
		(customerIds: string[]) => {
			setLocalCustomerIds(customerIds); // Update UI immediately
			if (customerDebounceRef.current) {
				clearTimeout(customerDebounceRef.current);
			}
			customerDebounceRef.current = setTimeout(() => {
				performFilterHandler('customerId', customerIds);
			}, 500);
		},
		[performFilterHandler]
	);

	const debouncedSetClasses = useCallback(
		(classIds: string[]) => {
			setLocalClassIds(classIds); // Update UI immediately
			if (classDebounceRef.current) {
				clearTimeout(classDebounceRef.current);
			}
			classDebounceRef.current = setTimeout(() => {
				performFilterHandler('classId', classIds);
			}, 500);
		},
		[performFilterHandler]
	);

	// Cleanup timeouts on unmount
	useEffect(() => {
		return () => {
			if (employeeDebounceRef.current) {
				clearTimeout(employeeDebounceRef.current);
			}
			if (customerDebounceRef.current) {
				clearTimeout(customerDebounceRef.current);
			}
			if (classDebounceRef.current) {
				clearTimeout(classDebounceRef.current);
			}
		};
	}, []);

	useEffect(() => {
		if (
			configurations &&
			configurations.settings &&
			classList &&
			classList.length
		) {
			const _classList = createModifiedArray(
				classList,
				configurations.settings[0].fields['f1'].value
			);
			setFilteredClassList(_classList);
		}
	}, [configurations, classList]);

	const handleChangeSearchValue = (value: any) => {
		performSearchHandler && performSearchHandler(value);
	};

	// Filter customer data to remove "Select Customer" option (only at parent level)
	const filteredCustomerData = useMemo(() => {
		if (!Array.isArray(customer)) {
			return [];
		}
		return customer.filter((item: any) => {
			// Filter out items with "Select Customer" title at parent level only
			return item?.title !== 'Select Customer';
		});
	}, [customer]);

	// Filter class data to remove "Select Class" option (only at parent level)
	const filteredClassData = useMemo(() => {
		if (!Array.isArray(filteredClassList)) {
			return [];
		}
		return filteredClassList.filter((item: any) => {
			// Filter out items with "Select Class" title at parent level only
			return item?.title !== 'Select Class';
		});
	}, [filteredClassList]);

	// Transform employees to treeData format for TreeSelect
	const employeeTreeData = useMemo(() => {
		return employees?.map((employee: any) => ({
			title: employee.fullName,
			value: employee.id,
			key: employee.id,
			children: [], // Empty for flat list
		})) || [];
	}, [employees]);

	// JSX
	return (
		<div className={styles['search-filter']}>
			<div
				className={`${styles['search-filter__wrapper']} search-filter-custom cost-allocation-search-filter`}
			>
				{/* <Row justify="space-between">
					<Col span={24} style={{ marginBottom: 8 }}>
						<Row justify="space-between" align="middle" gutter={[16, 16]}>
							<Col>
								<Space>
									<PayPeriodFilter
										payPeriodId={selectedPayPeriod}
										onChangePayPeriodId={(value) => {
											onChangePayPeriod(value);
										}}
									/>
									<Input
										className="search-filter__search"
										placeholder="Search here..."
										// style={{ fontSize: '12px' }}
										style={{ fontSize: '12px', minHeight: '40px' }}
										suffix={<SearchOutlined />}
										onChange={(e) => handleChangeSearchValue(e.target.value)}
										value={searchValue}
										size="large"
									/>
									<Select
										className={styles['search-filter__filter']}
										style={{ width: '100%' }}
										onChange={(value) =>
											performFilterHandler('employeeId', value)
										}
										size="large"
										placeholder="Employee"
										value={filterValue?.employeeId}
										showSearch
										allowClear
										filterOption={(input, option: any) =>
											(option?.children as string)
												.toLowerCase()
												.includes(input.toLowerCase())
										}
									>
										<Select.Option value="">Select Employee</Select.Option>
										{employees?.map((employee: any, index: number) => (
											<Select.Option value={employee?.id} key={index}>
												{employee?.fullName}
											</Select.Option>
										))}
									</Select>
									<TreeSelect
										className={styles['search-filter__tree-filter']}
										showSearch
										style={{ width: '100%' }}
										value={filterValue?.customerId}
										placeholder="Customer"
										allowClear
										treeDefaultExpandAll
										onChange={(value) =>
											performFilterHandler('customerId', value)
										}
										size="large"
										treeData={customer}
										filterTreeNode={(inputValue, treeNode) =>
											treeNode.props.title
												.toLowerCase()
												.includes(inputValue.toLowerCase())
										}
										treeLine
									/>
									<TreeSelect
										className={styles['search-filter__tree-filter']}
										showSearch
										style={{ width: '100%' }}
										value={filterValue?.classId}
										placeholder="Class"
										allowClear
										treeDefaultExpandAll
										onChange={(value) => performFilterHandler('classId', value)}
										size="large"
										treeData={filteredClassList}
										filterTreeNode={(inputValue, treeNode) =>
											treeNode.props.title
												.toLowerCase()
												.includes(inputValue.toLowerCase())
										}
										treeLine
									/> */}
				{/* <ClearFilter clearFilter={clearFilter} /> */}
				{/* <div className={styles['scaled-clear-filter']}>
										<ClearFilter clearFilter={clearFilter} />
									</div>
								</Space>
							</Col>

							<Col>
								{isCostAllocation == '1' && (
									<button
										onClick={() => onScreenChange?.()}
										className={styles['actions-layoutExpand']}
									>
										{isExpanded ? (
											<>
												<MinimizeIcon /> Minimize
											</>
										) : (
											<>
												<MaximizeIcon /> Maximize
											</>
										)}
									</button>
								)}
							</Col>
						</Row>
					</Col> */}
				{/* <Collapse
						bordered={activeKey.includes('1') ? true : false}
						expandIcon={() => null} // 👈 This removes the default arrow
						defaultActiveKey={activeKey}
						onChange={(key) => setActiveKey(key as string[])}
						style={{
							marginBottom: 6,
							backgroundColor: '#fff',
						}}
					>
						<Panel
							header={
								<div
									style={{
										display: 'inline-flex',
										justifyContent: 'flex-start',
										alignItems: 'center',
										height: 30,
										paddingRight: '4px 0',
									}}
								>
									<Button
										type="default"
										size="small"
										icon={
											activeKey.includes('1') ? (
												<CloseOutlined />
											) : (
												<FilterOutlined
													style={{ fontSize: 16, color: '#344735' }}
												/>
											)
										}
										onClick={() =>
											setActiveKey(activeKey.includes('1') ? [] : ['1'])
										}
										style={{
											fontWeight: 'bold',
											fontSize: 14,
											color: '#344735',
											background: 'transparent',
											padding: '2px 8px',
											border: 'none',
											height: 30,
										}}
									>
										Filters
									</Button>
								</div>
							}
							key="1"
						>
							<Card
								bordered={false}
								style={{
									borderRadius: 14,
									boxShadow: 'inherit',
									padding: 16,
								}}
							>
								<Row gutter={[16, 16]}>
									<Col xs={24} sm={12} md={8} lg={4}>
										<Input
											width="100%"
											placeholder="Search here..."
											suffix={<SearchOutlined />}
											onChange={(e) => handleChangeSearchValue(e.target.value)}
											value={searchValue}
											size="large"
										/>
									</Col>

									<Col xs={24} sm={12} md={8} lg={4}>
										<Select
											style={{ width: '100%' }}
											onChange={(value) =>
												performFilterHandler('employeeId', value)
											}
											size="large"
											placeholder="Employee"
											value={filterValue?.employeeId}
											showSearch
											allowClear
											filterOption={(input, option: any) =>
												(option?.children as string)
													.toLowerCase()
													.includes(input.toLowerCase())
											}
										>
											<Select.Option value="">Select Employee</Select.Option>
											{employees?.map((employee: any, index: number) => (
												<Select.Option value={employee?.id} key={index}>
													{employee?.fullName}
												</Select.Option>
											))}
										</Select>
									</Col>

									<Col xs={24} sm={12} md={8} lg={7}>
										<TreeSelect
											className={styles['search-filter__tree-filter']}
											showSearch
											style={{ width: '100%' }}
											value={filterValue?.customerId}
											placeholder="Customer"
											allowClear
											treeDefaultExpandAll
											onChange={(value) =>
												performFilterHandler('customerId', value)
											}
											size="large"
											treeData={customer}
											filterTreeNode={(inputValue, treeNode) =>
												treeNode.props.title
													.toLowerCase()
													.includes(inputValue.toLowerCase())
											}
											treeLine
										/>
									</Col>

									<Col xs={24} sm={12} md={8} lg={7}>
										<TreeSelect
											className={styles['search-filter__tree-filter']}
											showSearch
											style={{ width: '100%' }}
											value={filterValue?.classId}
											placeholder="Class"
											allowClear
											treeDefaultExpandAll
											onChange={(value) =>
												performFilterHandler('classId', value)
											}
											size="large"
											treeData={filteredClassList}
											filterTreeNode={(inputValue, treeNode) =>
												treeNode.props.title
													.toLowerCase()
													.includes(inputValue.toLowerCase())
											}
											treeLine
										/>
									</Col>

									<Col
										xs={24}
										sm={12}
										md={8}
										lg={2}
										style={{ display: 'flex', alignItems: 'end' }}
									>
										<ClearFilter clearFilter={clearFilter} />
									</Col>
								</Row>
							</Card>
						</Panel>
					</Collapse> */}
				{/* </Row> */}

				<Row
					className={styles['custom-row']}
					align="middle"
					justify="space-between"
				>
					<Col>
						<Space wrap>
							{/* <Space wrap size={[16, 16]}> */}
							<PayPeriodFilter
								payPeriodId={selectedPayPeriod}
								onChangePayPeriodId={(value) => onChangePayPeriod(value)}
							/>

							<Input
								placeholder="Search here..."
								style={{ fontSize: '12px', minWidth: 200, height: 40 }}
								suffix={<SearchOutlined />}
								onChange={(e) => handleChangeSearchValue(e.target.value)}
								value={searchValue}
								size="large"
							/>

							<TreeSelect
								placeholder="Employees"
								value={localEmployeeIds}
								onChange={debouncedSetEmployees}
								showSearch
								allowClear
								multiple
								maxTagCount={0}
								size="large"
								style={{ minWidth: 200, fontSize: '12px', height: 40 }}
								treeData={employeeTreeData}
								treeLine
								treeDefaultExpandAll
								filterTreeNode={(inputValue, treeNode) =>
									treeNode?.props?.title
										?.toLowerCase()
										.includes(inputValue.toLowerCase())
								}
								onDropdownVisibleChange={(open) => {
									setEmployeesTooltipDisabled(open);
								}}
								maxTagPlaceholder={() => {
									const selectedEmployeeIds = localEmployeeIds;

									if (selectedEmployeeIds.length === 0) return 'Employees';

									const employeeLabels = selectedEmployeeIds.map((id: string) => {
										const employee = employees?.find((emp: any) => emp.id === id);
										return employee?.fullName || id;
									});

									return (
										<Tooltip
											title={
												<div className="filter-tooltip-content">
													{employeeLabels.map((label: string, i: number) => (
														<div
															key={i}
															className="filter-tooltip-item"
															style={{
																borderBottom:
																	i !== employeeLabels.length - 1
																		? '1px solid rgba(52, 71, 53, 0.1)'
																		: 'none',
															}}
														>
															{label}
														</div>
													))}
												</div>
											}
											placement="bottom"
											overlayClassName="filter-tooltip"
											visible={employeesTooltipDisabled ? false : undefined}
											trigger={employeesTooltipDisabled ? [] : ['hover']}
										>
											Employees ({selectedEmployeeIds.length})
										</Tooltip>
									);
								}}
							/>

							<TreeSelect
								placeholder="Customers"
								value={localCustomerIds}
								onChange={debouncedSetCustomers}
								size="large"
								allowClear
								multiple
								maxTagCount={0}
								treeDefaultExpandAll
								showSearch
								treeData={filteredCustomerData}
								style={{ minWidth: 200, fontSize: '12px', height: 40 }}
								filterTreeNode={(inputValue, treeNode) =>
									treeNode?.props?.title
										?.toLowerCase()
										.includes(inputValue.toLowerCase())
								}
								treeLine
								onDropdownVisibleChange={(open) => {
									setCustomersTooltipDisabled(open);
								}}
								maxTagPlaceholder={() => {
									const selectedCustomerIds = localCustomerIds;

									if (selectedCustomerIds.length === 0) return 'Customers';

									const customerLabels = selectedCustomerIds.map((id: string) => {
										return getOptionLabel(id, filteredCustomerData) || id;
									});

									return (
										<Tooltip
											title={
												<div className="filter-tooltip-content">
													{customerLabels.map((label: string, i: number) => (
														<div
															key={i}
															className="filter-tooltip-item"
															style={{
																borderBottom:
																	i !== customerLabels.length - 1
																		? '1px solid rgba(52, 71, 53, 0.1)'
																		: 'none',
															}}
														>
															{label}
														</div>
													))}
												</div>
											}
											placement="bottom"
											overlayClassName="filter-tooltip"
											visible={customersTooltipDisabled ? false : undefined}
											trigger={customersTooltipDisabled ? [] : ['hover']}
										>
											Customers ({selectedCustomerIds.length})
										</Tooltip>
									);
								}}
							/>

							<TreeSelect
								placeholder="Classes"
								value={localClassIds}
								onChange={debouncedSetClasses}
								size="large"
								allowClear
								multiple
								maxTagCount={0}
								treeDefaultExpandAll
								showSearch
								treeData={filteredClassData}
								style={{ minWidth: 200, fontSize: '12px', height: 40 }}
								filterTreeNode={(input, treeNode) =>
									treeNode?.props?.title
										?.toLowerCase()
										.includes(input.toLowerCase())
								}
								treeLine
								onDropdownVisibleChange={(open) => {
									setClassesTooltipDisabled(open);
								}}
								maxTagPlaceholder={() => {
									const selectedClassIds = localClassIds;

									if (selectedClassIds.length === 0) return 'Classes';

									const classLabels = selectedClassIds.map((id: string) => {
										return getOptionLabel(id, filteredClassData) || id;
									});

									return (
										<Tooltip
											title={
												<div className="filter-tooltip-content">
													{classLabels.map((label: string, i: number) => (
														<div
															key={i}
															className="filter-tooltip-item"
															style={{
																borderBottom:
																	i !== classLabels.length - 1
																		? '1px solid rgba(52, 71, 53, 0.1)'
																		: 'none',
															}}
														>
															{label}
														</div>
													))}
												</div>
											}
											placement="bottom"
											overlayClassName="filter-tooltip"
											visible={classesTooltipDisabled ? false : undefined}
											trigger={classesTooltipDisabled ? [] : ['hover']}
										>
											Classes ({selectedClassIds.length})
										</Tooltip>
									);
								}}
							/>

							<div className={styles['scaled-clear-filter']}>
								<ClearFilter clearFilter={clearFilter} />
							</div>
						</Space>
					</Col>
					{/*
					<Col
					>
						{isCostAllocation === '1' && (
							<button
								onClick={() => onScreenChange?.()}
								className={styles['actions-layoutExpand']}
							>
								{isExpanded ? (
									<>
										<MinimizeIcon /> Minimize
									</>
								) : (
									<>
										<MaximizeIcon /> Maximize
									</>
								)}
							</button>
						)}
					</Col> */}
				</Row>
			</div>
		</div>
	);
};

export default SearchAndFilter;
